import { nanoid } from "nanoid";

export const state = {
  pageErrors: []
}

export const getters = {
  pageErrors(state) {
    return state.pageErrors;
  },
  hasPageErrors(state) {
    return state.pageErrors.length;
  }
}

export const mutations = {
  addPageError(state, error) {
    if (error.response && error.response.status !== 401) {
      state.pageErrors.push({ message: error, id: nanoid() });
    }
  },
  clear(state) {
    state.pageErrors = [];
  }
}

export const actions = {
  addPageError({ commit }, error) {
    commit('addPageError', error);
  },
  clearPageErrors({ commit }) {
    commit('clear');
  }
}
